"use strict";

import { useMemo } from 'react';
import { getImageServerSrc, getImageServerSrcset } from '../lib';
export const useAgImageServerUrl = ({
  url,
  quality: _quality = 60
}) => {
  if (!url || !_quality) return {
    src: null,
    srcset: null
  };
  return useMemo(() => ({
    src: getImageServerSrc({
      url,
      quality: _quality,
      width: 640
    }),
    srcset: getImageServerSrcset({
      url,
      quality: _quality
    })
  }), [url, _quality]);
};